<template>
  <div class="user_info_body">
    <div class="deco">
      <template>
        <h3>변경하실 사업자 유형을 선택해 주세요.</h3>
        <p>
          사업자로 사용자 유형을 변경하시면, 서류를 검토 후 승인 처리 된 다음부터 사업자로 서비스를 이용할 수 있습니다.
        </p>
      </template>
      <div class="radio-box-group">
        <radio-box
          v-if="userInfo.businessType !== 1"
          name="userType"
          text="개인"
          id="type1"
          :value="1"
          v-model="picked"
        />
        <radio-box name="userType" text="개인사업자 (세금계산서)" id="type2" :value="2" v-model="picked" />
        <radio-box name="userType" text="법인사업자 (세금계산서)" id="type3" :value="3" v-model="picked" />
      </div>
      <p class="warn_msg">※ 리워드서비스는 만 14세 이상 회원에 한하여 이용할 수 있습니다.</p>
      <div class="user_info_caution">
        <h3>사업자 회원 유의 사항</h3>
        <ul>
          <li>사업자의 경우 개인사업자와 영리법인만 가능합니다.</li>
          <li>사업자 회원은 매월 취득한 포인트에 대해서 세금계산서 발행 후 수익정산을 해야 합니다</li>
          <li class="blue">세금계산서 발행이 불가능한 개인사업자는 개인회원으로 이용해주세요</li>
          <li>
            사업자로 신청하신 경우 필요서류
            <strong
              >(사업자 등록증 사본 / 통장 사본 / 인감 증명서 /
              <a href="/static/account-check.docx" download="계좌확인서.docx">계좌 확인서</a>)</strong
            >를 보내주셔야 합니다.
          </li>
          <li>사업자 회원의 서류를 검토한 뒤 승인 처리된 다음부터 사업자로 서비스를 이용할 수 있습니다.</li>
        </ul>
      </div>
      <div class="bt bt100">
        <v-button
          text="다음"
          class="btn01"
          @handleClick="handleClick"
          ref="btn_change"
          :disabled="picked === 0"
        ></v-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RadioBox from '@/components/atoms/RadioBox';
import VButton from '@/components/atoms/VButton';

export default {
  components: {
    RadioBox,
    VButton,
  },
  data() {
    return {
      picked: 0,
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    ...mapActions('userInfo', ['setRegisterSelect']),
    handleClick() {
      this.setRegisterSelect(this.picked);
      // 여기 확인해야함.
      return this.$router
        .push({
          name: 'UserInfoRegister',
          query: {
            ...this.$route.query,
          },
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.user_info_body {
  .warn_msg {
    margin-top: 20px;
    color: #050c42;
    line-height: 1.43;
    font-size: 14px;
  }
  .user_info_caution {
    h3 {
      border-top: 1px solid #ddd;
      padding-top: 30px;
      padding-bottom: 12px;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.29;
      color: #666;
    }
    ul > li {
      &.blue {
        color: #137fe2;
      }
      strong {
        color: #17191d;
        font-weight: bold;
      }
    }
  }
}
</style>
